import 'isomorphic-fetch';
import { Aurelia, LogManager, TemplatingEngine } from 'aurelia-framework';
import * as Bluebird from 'bluebird';
import { AppSettings } from './app/utils/appsettings';
import { NotificationErrorLogger } from './app/utils/notification-error-logger';
import { RaygunErrorLogger } from './app/utils/raygun-error-logger';
import { ResourceService } from './app/utils/resourceService';
import { ValidationConfig } from './app/utils/validation-config';
import { forEach } from 'lodash';
import 'es6-set';
import 'es6-map';
import * as numeral from 'numeral';
import 'numeral/locales/fi';
import { ScopedLinkHandler } from "./scoped-link-handler";
import { LinkHandler } from "aurelia-history-browser";
import { PLATFORM } from 'aurelia-pal';

declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build

Bluebird.config( { warnings: false, longStackTraces: false } );

// reference the V4 version of the library as dependency
window['bsn'] = require('bootstrap.native/dist/bootstrap-native');


function enhanceNode(aurelia: Aurelia, node: Element, bindingContext = null) {
	const engine = aurelia.container.get(TemplatingEngine);
	const component = engine.enhance({ container: aurelia.container, element: node, resources: aurelia.resources, bindingContext: bindingContext });
	component.attached();
}

export function configure(aurelia: Aurelia) {
	aurelia.use
		.basicConfiguration()
		.router()
		.history()
		.feature(PLATFORM.moduleName('app/components/index'))
		.feature(PLATFORM.moduleName('app/features/index'))
		.globalResources([
			PLATFORM.moduleName('app/utils/resources'),
			PLATFORM.moduleName('app/utils/translations'),
			PLATFORM.moduleName('app/utils/value-converters'),
			PLATFORM.moduleName('app/utils/custom-attributes')
		])
		.plugin(PLATFORM.moduleName('aurelia-validation'));

	if (IS_DEV_BUILD) {
		aurelia.use.developmentLogging();

		const notificationErrorLogger = aurelia.container.get(NotificationErrorLogger);

		LogManager.addAppender(notificationErrorLogger);
	} else {
		const raygunErrorLogger = new RaygunErrorLogger(AppSettings.raygunApiKey, AppSettings.applicationVersion, AppSettings.email);
		raygunErrorLogger.activate();
		LogManager.addAppender(raygunErrorLogger);
		LogManager.setLevel(LogManager.logLevel.error);
	}

	aurelia.container.registerSingleton(LinkHandler, ScopedLinkHandler);

	const resourceService = aurelia.container.get(ResourceService);
	const resourcesLoaded = resourceService.loadResources();
	const aureliaStarted = aurelia.start();

	Promise.all([aureliaStarted, resourcesLoaded])
		.then((returnValues) => {

			const au = returnValues[0];

			const validationConfig = au.container.get(ValidationConfig) as ValidationConfig;
			validationConfig.configure();

			numeral.locale('fi');

			const element = document.querySelector("[aurelia-root]");
			if (element) {
				au.setRoot(element.getAttribute('aurelia-root'), element);
				const nodes = document.querySelectorAll("#main-header, #layout-link-toolbar, #navigation-bar, notifications-container");
				forEach(nodes, node => enhanceNode(au, node));
			} else {
				au.enhance({}, document.body)
					.catch((error) => {
						LogManager.getLogger('app-startup').error(error);
					});
			}
		});
}
